import coin1 from '../../../assets/images/coin-1-print.png'
import coin5 from '../../../assets/images/coin-5-print.png'
import coin10 from '../../../assets/images/coin-10-print.png'
import coin25 from '../../../assets/images/coin-25-print.png'
import coin50 from '../../../assets/images/coin-50-print.png'

class PrintController {
  /*@ngInject*/
  constructor(Auth, $state, Modal, $translate, $stateParams, RouteService, DateUtil) {
    this.Modal = Modal
    this.Auth = Auth
    this.$state = $state
    this.$translate = $translate
    this.$stateParams = $stateParams
    this.RouteService = RouteService
    this.DateUtil = DateUtil
    this.id = 'print'
    this.routeSheet = []
    this.model = {}
    this.model.route = {}
    this.model.date = new Date('2017-01-01')
  }

  computeData(routeSheet) {
    let totalBags = 0;
    let totalKeys = 0;
    let coinTypeOrder = ['B', 'H', 'L'];
    
    routeSheet.forEach((r) => {
      let sortedCoinsOrder = Object.keys(r.totals);
      
      totalBags += r.totalCashShipments || 0;
      if(r.keyNum) {
        totalKeys++;
      }

      sortedCoinsOrder = sortedCoinsOrder.sort((coinA, coinB) => {
        let coinAVal = coinA.indexOf('1$') >= 0 ? 100 : parseInt(coinA);
        let coinBVal = coinB.indexOf('1$') >= 0 ? 100 : parseInt(coinB);;

        //add weights for coin types i.e. B, H and L
        coinAVal += coinTypeOrder.indexOf(coinA.charAt(2));
        coinBVal += coinTypeOrder.indexOf(coinB.charAt(2));

        return coinAVal - coinBVal;
      });

      r.sortedCoinsOrder = sortedCoinsOrder;
      r.coinTypes = r.sortedCoinsOrder.length;

      // dont call bagStack in ngRepeat as it returns fresh array every time it will lead to digest cycle error
      r.bagStack = this.bagStack(r.coinTypes, r.trackingIds);
      // delete r.trackingIds;
    });

    this.totalBags = totalBags;
    this.totalKeys = totalKeys;
  }

  bagStack(coinTypes, bags){
    const array = []
    let i,j,chunk = 0;

    // column height is dependent on coinTypes so change the chunk size accordingly
    if(coinTypes > 12) {
      chunk = 6;
    }
    else if(coinTypes > 6 && coinTypes <= 12) {
      chunk = 4;
    }
    else {
      chunk = 3;
    }

    for (i=0,j=bags.length; i<j; i+=chunk) {
        array.push(bags.slice(i,i+chunk))
    }

    return array
  }

  $onInit() {    
    let printData = undefined; 
    
    if(window.opener && window.opener.w && window.opener.w.printData && window.opener.w.printData.generateSheet){
      printData = window.opener.w.printData
    }
    else if(this.$stateParams.route && this.$stateParams.date && this.$stateParams.branch) {
      const 
      routeId = this.$stateParams.route,
      dateString = this.$stateParams.date,
      branchName = this.$stateParams.branch
      this.loading = true;
      return this.RouteService.get(routeId)
        .then((route) => {
          this.model.route = route
          this.model.barcodeId = this.$stateParams.prefix ? this.$stateParams.prefix + route.id : route.id
          this.model.date = dateString
          this.branchName = branchName
          return this.RouteService.sheet(routeId, new Date(dateString));
        })
        .then((data) => {
          const routeSheet = data.records;
          this.branchId = data.branch;
          this.driverId = data.driverId;
          this.messengerId = data.messengerId;
          this.guardId = data.guardId;
          this.vehicleId = data.vehicleId;
          this.computeData(routeSheet);
          this.routeSheet = routeSheet
          this.noDataFound = true; 
          // this.totalBags = 0
          // this.routeSheet.forEach((r) => {
          //   this.totalBags += r.totalCashShipments
          //   r.coinTypes = Object.keys(r.totals).length;
          // })
          this.loading = false;
          return data.records && data.records.length;
        })
        .then((shouldPrint) => {
          if(shouldPrint) {
            setTimeout(() => {
              window.print()
            }, 1000)
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log('Some error', err)
        })
    }    

    this.routeSheet = printData.data;
    this.model = printData.model;
    this.totalBags = printData.totalBags;
    this.branchName = printData.branchName;
    this.branchId = printData.branchId;
    this.driverId = printData.driverId;
    this.messengerId = printData.messengerId;
    this.guardId = printData.guardId;
    this.vehicleId = printData.vehicleId;
    this.totalKeys = printData.totalKeys;
    
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  bagStack(cointTypes, bags){
    const array = []
    let i,j,chunk = 0;

    // column height is dependent on cointTypes so change the chunk size accordingly
    if(cointTypes > 12) {
      chunk = 6;
    }
    else if(cointTypes > 6 && cointTypes <= 12) {
      chunk = 4;
    }
    else {
      chunk = 3;
    }

    for (i=0,j=bags.length; i<j; i+=chunk) {
        array.push(bags.slice(i,i+chunk))
    }

    return array
  }

  icon(key){
    key = key.substr(0, key.length-1);
    switch(key){
      case '01':
        return coin1
      case '05':
        return coin5
      case '25':
        return coin25
      case '50':
        return coin50
      case '10':
        return coin10
      default:
        return coin1
    }    
  }
}

export default PrintController;



// WEBPACK FOOTER //
// ./client/app/components/routeSheet/print/print.controller.js